<template>
  <div>
    <h3>HOME</h3>
    <router-link to="/start">Hero Test</router-link>
  </div>
</template>


<script>
export default {
  name: 'Home',
  data() {
    return {
    }
  },
  computed: {
    gameStoredata () {
      return this.$store.getters.StoreGameData
    },
  }
}
</script>

<style scoped>
  .gameDataContainer .dataBlock {
    width: 30%;
    min-width: 200px;
    display: inline-block;
  }
</style>

